import { VField } from '../../components/Fields'
import { Intervento } from '../../types'

export default function FormAnnullaIntervento({
  intervento,
}: {
  intervento: Intervento | null
}) {
  return (
    <div className="row">
      <div className="col-md-12">
        <div>
          Confermi l'annullamento dell'intervento n°{' '}
          <strong>{intervento?.id}?</strong>
        </div>
        <div className="text-danger mt-3">Questa scelta è irreversibile.</div>
        <div className="mt-2">
          Puoi inserire qui sotto eventuali note/informazioni aggiuntive.
        </div>
        <VField name="note_annullamento" label="Note" as="textarea" />
      </div>
    </div>
  )
}
